import VisionValue from './assets/visionvalue.png'
import weixinqrcode from './assets/weixinqrcode.png'
import map from './assets/map.png'
import { useLocation } from 'react-router'
import { CenterBox } from './compnents'

export const FooterContent = () => {
    const location = useLocation()
    const show = location.pathname !== '/contractus' ? 'Block' : 'None'

    return <div style={{ display: show, position: 'relative', height: '82.4rem' }}>
        <CenterBox style={{ top: '9.7rem' }}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                <img style={{ marginBottom: '6rem' }} src={VisionValue} alt={'远见未来'} />
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-start' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', marginRight: '7rem' }}>
                        <h4 style={{ marginBottom: '3rem', color: 'white' }}>办公地址：</h4>
                        <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                            <h5 style={{ color: 'white' }}>北京总部：</h5>
                            <div style={{ fontSize: '1.2rem', lineHeight: '1rem', marginLeft: '3.7rem', marginTop: '0.7rem', marginBottom: '3rem' }}>
                                <p>北京市西城区太平街甲6号富力摩根中心E座10层1015室</p>
                                <p>电&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;话：010-63159020</p>
                                <p>邮&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;箱：zongyi@visiontmt.com</p>
                                <p>联&nbsp;&nbsp;系&nbsp;&nbsp;人：宗女士</p>
                                <p>联系电话：18710134878</p>
                            </div>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '4rem' }}>
                            <h5 style={{ color: 'white' }}>上海分公司：</h5>
                            <div style={{ fontSize: '1.2rem', lineHeight: '1rem', marginLeft: '2rem', marginTop: '0.7rem' }}>
                                <p>上海市徐汇宜山路407号徐汇尚光中心金座1301室</p>
                                <p>联&nbsp;&nbsp;系&nbsp;&nbsp;人：秦先生</p>
                                <p>联系电话：13795364908</p>
                            </div>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginLeft: '5rem' }}>
                            <img src={weixinqrcode} alt={'微信二维码'} style={{ objectFit: 'cover' }} />
                            <span style={{ marginTop: '0.7rem', fontFamily: '微软雅黑', fontSize: '1.6rem' }}>微信公众号</span>
                        </div>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginRight: '7rem' }}>
                        <h4 style={{ color: 'white', marginBottom: '3rem' }}>关于远见</h4>
                        <div style={{ fontSize: '1.4rem', lineHeight: '2.5rem', marginBottom: '4rem' }}>
                            <p>了解远见</p>
                            <p>加入远见</p>
                            <p>帮助中心</p>
                        </div>

                        <h4 style={{ color: 'white', marginBottom: '3rem' }}>联系我们</h4>
                        <div style={{ fontSize: '1.4rem', lineHeight: '2.5rem' }}>
                            <p>售前咨询</p>
                            <p>售后支持</p>
                        </div>
                    </div>
                    <div>
                        <img src={map} alt={'map'} style={{ width: '50rem', height: '30rem' }} />
                        {/* <iframe title={'地图'} src={'map.html'} style={{ position: 'absolute', left: '102.2rem', top: '21rem', width: '50rem', height: '30rem' }} scrolling={'no'}></iframe> */}
                    </div>
                </div>
            </div>
        </CenterBox >
    </div >
}